export const MENSAGENS_PADRAO = {
  REGISTRO_SALVO: 'Registro salvo com sucesso.',
  REGISTRO_ATUALIZADO: 'Registro atualizado com sucesso.',
  REGISTRO_INATIVADO: 'Registro inativado com sucesso.',
  REGISTRO_NAO_ENCONTRADO: 'Registro não encontrado.',
  ERRO_INESPERADO: 'Ocorreu um erro inesperado. Tente novamente ou contate o administrador do sistema.',
  OPERACAO_INDISPONIVEL: 'Não foi possível concluir a operação no momento.',
  USUARIO_SEM_PERMISSAO: 'Usuário não possui permissão para executar esta ação.',
  USUARIO_NAO_AUTENTICADO: 'Usuário não autenticado.',
  CAMPO_OBRIGATORIO: 'Campo obrigatório.',
  EMAIL_INVALIDO: 'Informe um e-mail válido.',
  CPF_CNPJ_INVALIDO: 'Informe um CPF ou CNPJ válido.',
  CNPJ_INVALIDO: 'Informe um CNPJ válido.',
  CPF_INVALIDO: 'Informe um CPF válido.',
  SENHAS_NAO_CONFEREM: 'As senhas não conferem.',
  JUSTIFICATIVA_ACAO_CRITICA_OBRIGATORIA: 'Justificativa é obrigatória para ação crítica.',
} as const;
